import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAbletonliveComponent } from './simple-icons-abletonlive.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAbletonliveComponent ],
    exports:      [ SimpleIconsAbletonliveComponent ],
    bootstrap:    []
})
export class SimpleIconsAbletonliveModule {}
